// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --------A Modern CSS Reset by Josh Comeau-------- */

/* 1. Use a more-intuitive box-sizing model */
*, *::before, *::after {
  box-sizing: border-box;
  /* 2. Remove default margin and padding*/
  margin: 0;
  padding: 0;
  /* border: 1px solid black; */
}

/* 3. Enable keyword animations */
@media (prefers-reduced-motion: no-preference) {
  html {
    interpolate-size: allow-keywords;
  }
}

body {
  /* 4. Add accessible line-height */
  line-height: 1.5;
  /* 5. Improve text rendering */
  -webkit-font-smoothing: antialiased;
}

/* 6. Improve media defaults */
img, picture, video, canvas, svg {
  display: block;
  max-width: 100%;
}
img{
  height: 100%;
  width: 100%;
}
/* 7. Inherit fonts for form controls */
input, button, textarea, select {
  font: inherit;
}

/* 8. Avoid text overflows */
p, h1, h2, h3, h4, h5, h6 {
  overflow-wrap: break-word;
}

/* 9. Improve line wrapping */
p {
  text-wrap: pretty;
}
h1, h2, h3, h4, h5, h6 {
  text-wrap: balance;
}

/*
  10. Create a root stacking context
*/
#root, #__next {
  isolation: isolate;
}

/* --------CSS reset above-------- */

/*colors*/
:root{
  --white: white;
  --black: black;
  --transperant-white: rgb(255, 255, 255,0.7);
  --red: rgb(181, 25, 25);
  --light-black: rgb(0, 0, 0,0.4);
  --light-black2: rgb(0, 0, 0,0.1);
  --light-black3: rgb(0, 0, 0,0.3);
  --grey: rgb(255, 255, 255,0.1);
  --dark-grey: rgb(255, 255, 255,0.3);
  /*homepage*/
  --color-heading-hero: var(--white);
  --color-search-btn-home: var(--white);
  --color-search-home: var(--white);
  --color-underline-search-home: var(--white);
  --color-underline-search-btn-home: var(--white);
  --bg-color-search-btn-home: var(--light-black);
  --bg-color-search-home: var(--light-black3);
  /*error*/
  --bg-color-header-error: var(--red);
  --color-header-error: var(--white);
  /*data page*/
  --bg-color-data-page-right: var(--light-black);
  --bg-color-data-page-left: var(--light-black);
  --bg-color-search-data: var(--grey);
  --bg-color-search-btn-data: var(--light-black2);
  --color-underline-search-data: var(--white);
  --color-underline-search-btn-data: var(--white);
}

.main{
  height: 100vh;
}
.bg_image{
  position: absolute;
  z-index: -1;
  width: 100%;
  height: 100%;
  min-width: 1320px;
  left: 0;
  top: 0;
}
input[type='search']::placeholder{
  color: var(--white);
}
/*----------home page styling----------*/
.home_page_holder{
  padding-top: 100px;
  padding-left: 10px;
  padding-right: 10px;
}
.hero_heading,
.hero_para{
  text-align: center;
  color: var(--color-heading-hero);
}
.hero_heading{
  font-size: 3rem;
}
.hero_para{
  font-size: 1.5rem;
}
.home_search_form{
  display: flex;
  height: 50px;
  justify-content: center;
}
.hero_section{
  margin-bottom: 50px;
}
.home_search_input{
  width: 60vw;
  padding-left: 10px;
  outline: none;
  border: none;
  border-bottom: 2px solid var(--color-underline-search-home);
  background-color: var(--bg-color-search-home);
  color: var(--white);
  font-size: 1.2rem;
}
.home_search_input::-webkit-search-cancel-button{
  appearance: none;
}
.home_search_btn{
  /* width: 50px; */
  border: none;
  border-bottom: 2px solid var(--color-underline-search-btn-home);
  background-color: var(--bg-color-search-btn-home);
  fill: var(--color-search-btn-home);
}
.home_bg_image{
  position: absolute;
  z-index: -1;
  width: 100%;
  min-width: 1220px;
  left: 0;
  top: 0;
}
.home_search_btn svg{
  pointer-events: none;
  width: 3rem;
}
.loading_screen{
  height: 100%;
  width: 100%;
  display: grid;
  place-content: center;
  background-color: var(--transperant-white);
  position: fixed;
  top: 0;
}

/*Error dialog box*/
.error_holder{
  width: 70vw;
  max-width: 300px;
  height: 100px;
}
.error_dialog{
  position: absolute;
  top: 220px;
  margin: 0 auto;
}
.error_header{
  display: flex;
  background-color: var(--bg-color-header-error);
}
.error_heading{
  flex: 1;
  text-align: start;
  font-size: 1.1rem;
  padding-left: 10px;
  color: var(--color-header-error);
}
.error_header button{
  width: 30px;
}
.error_close_btn_svg{
  pointer-events: none;
}
.error_text{
  padding: 10px;
}

/*Data page*/
.data_page_holder{
  display: grid;
  grid-template-columns: 5fr 6fr;
  padding: 30px;
  gap: 15vw;
  height: 100%;
}
/*left*/
.data_page_left{
  display: grid;
  align-content: start;
  gap: 10px;
  background-color: var(--bg-color-data-page-left);
  color: var(--white);
  padding: 30px;
  border-radius: 10px;
  fill: var(--white);
  position: relative;
}
.home_btn_svg_holder svg{
  width: 3rem;
}
.data_page_search_btn{
  border: none;
  border-bottom: 2px solid var(--color-underline-search-btn-data);
  background-color: var(--bg-color-search-btn-data);
}
.data_page_search_btn svg{
  width: 2.3rem;
  pointer-events: none;
}
.data_page_search_input::-webkit-search-cancel-button{
  appearance: none;
}
.data_page_search_input{
  width: 60%;
  padding-left: 10px;
  outline: none;
  border: none;
  border-bottom: 2px solid var(--white);
  background-color: var(--bg-color-search);
  color: var(--white);
  font-size: 1.2rem;
  flex: 1;
}
.data_page_search_form{
  display: flex;
  /* height: 50px; */
}
.assist_display{
  height: 20px;
}
.change_unit_btn_holder{
  display: flex;
  align-items: center;
  gap: 20px;
  font-size: 1.2rem;
}
.credits_for_data_page{
  width: 100%;
  height: 25px;
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: 10px;
  align-items: center;
  gap: 10px;
}
.credits_for_data_page svg{
  width: 1.5rem;
}
/*right*/
.intro_top>.intro_temp_display{
  font-size: 6rem;
  text-align: center;
}
.intro_icon_holder{
  display: flex;
}
.intro_icon_holder svg{
  width: 3.5rem;
}
.intro_bottom{
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}
.intro_location_info_holder>p:first-of-type{
  font-size: 1.5rem;
}
.data_page_right>h2{
  font-size: 1.2rem;
  border-top: 1px solid var(--white);
  /* border-top-color: var(--white); */
}
.data_page_right>.data_card{
  height: 50px;
  display: grid;
  grid-template-columns: 4fr 4fr 1fr;
  align-items: center;
}
.data_page_right{
  display: grid;
  gap: 5px;
  overflow: auto;
  padding: 30px;
  background-color: var(--bg-color-data-page-right);
  color: var(--white);
  fill: var(--white);
  border-radius: 10px;
  /* background-color: rgb(255, 255, 255,0.4);
  color: black; */
}
.data_page_right>.data_card>p{
  padding-left: 10px;
}
.data_page_right>.data_card>p+p{
  text-align: end;
}
.data_page_right>.data_card>div>svg{
  width: 1.8rem;
}
.data_page_right>.data_card>div{
  display: flex;
  justify-content: center;
}
::-webkit-scrollbar{
  background-color: transparent;
  width: 3px;
  height: 3px;
}
::-webkit-scrollbar-thumb{
  background-color: white;
  border-radius: 2px;
}
/*credits*/
.credits{
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 25px;
  z-index: 1;
  display: flex;
  justify-content: center;
  color: white;
  fill: white;
  align-items: center;
  gap: 10px;
  background-color: var(--light-black3);
}
.credits svg{
  width: 1.5rem;
}`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA,sDAAsD;;AAEtD,6CAA6C;AAC7C;EACE,sBAAsB;EACtB,wCAAwC;EACxC,SAAS;EACT,UAAU;EACV,6BAA6B;AAC/B;;AAEA,iCAAiC;AACjC;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA,8BAA8B;AAC9B;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA,uCAAuC;AACvC;EACE,aAAa;AACf;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;;AAEA;;CAEC;AACD;EACE,kBAAkB;AACpB;;AAEA,oCAAoC;;AAEpC,SAAS;AACT;EACE,cAAc;EACd,cAAc;EACd,2CAA2C;EAC3C,uBAAuB;EACvB,+BAA+B;EAC/B,gCAAgC;EAChC,gCAAgC;EAChC,8BAA8B;EAC9B,mCAAmC;EACnC,WAAW;EACX,kCAAkC;EAClC,qCAAqC;EACrC,iCAAiC;EACjC,2CAA2C;EAC3C,+CAA+C;EAC/C,8CAA8C;EAC9C,2CAA2C;EAC3C,QAAQ;EACR,mCAAmC;EACnC,kCAAkC;EAClC,YAAY;EACZ,8CAA8C;EAC9C,6CAA6C;EAC7C,mCAAmC;EACnC,+CAA+C;EAC/C,2CAA2C;EAC3C,+CAA+C;AACjD;;AAEA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,OAAO;EACP,MAAM;AACR;AACA;EACE,mBAAmB;AACrB;AACA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,2DAA2D;EAC3D,6CAA6C;EAC7C,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,+DAA+D;EAC/D,iDAAiD;EACjD,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,OAAO;EACP,MAAM;AACR;AACA;EACE,oBAAoB;EACpB,WAAW;AACb;AACA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,0CAA0C;EAC1C,eAAe;EACf,MAAM;AACR;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;AAChB;AACA;EACE,aAAa;EACb,8CAA8C;AAChD;AACA;EACE,OAAO;EACP,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,WAAW;AACb;AACA;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;AACf;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,SAAS;EACT,YAAY;AACd;AACA,OAAO;AACP;EACE,aAAa;EACb,oBAAoB;EACpB,SAAS;EACT,gDAAgD;EAChD,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;EACZ,+DAA+D;EAC/D,iDAAiD;AACnD;AACA;EACE,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,qCAAqC;EACrC,wCAAwC;EACxC,mBAAmB;EACnB,iBAAiB;EACjB,OAAO;AACT;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;AACf;AACA,QAAQ;AACR;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,oCAAoC;AACtC;AACA;EACE,YAAY;EACZ,aAAa;EACb,kCAAkC;EAClC,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;EACd,aAAa;EACb,iDAAiD;EACjD,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB;iBACe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,6BAA6B;EAC7B,UAAU;EACV,WAAW;AACb;AACA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;AACA,UAAU;AACV;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,SAAS;EACT,qCAAqC;AACvC;AACA;EACE,aAAa;AACf","sourcesContent":["/* --------A Modern CSS Reset by Josh Comeau-------- */\n\n/* 1. Use a more-intuitive box-sizing model */\n*, *::before, *::after {\n  box-sizing: border-box;\n  /* 2. Remove default margin and padding*/\n  margin: 0;\n  padding: 0;\n  /* border: 1px solid black; */\n}\n\n/* 3. Enable keyword animations */\n@media (prefers-reduced-motion: no-preference) {\n  html {\n    interpolate-size: allow-keywords;\n  }\n}\n\nbody {\n  /* 4. Add accessible line-height */\n  line-height: 1.5;\n  /* 5. Improve text rendering */\n  -webkit-font-smoothing: antialiased;\n}\n\n/* 6. Improve media defaults */\nimg, picture, video, canvas, svg {\n  display: block;\n  max-width: 100%;\n}\nimg{\n  height: 100%;\n  width: 100%;\n}\n/* 7. Inherit fonts for form controls */\ninput, button, textarea, select {\n  font: inherit;\n}\n\n/* 8. Avoid text overflows */\np, h1, h2, h3, h4, h5, h6 {\n  overflow-wrap: break-word;\n}\n\n/* 9. Improve line wrapping */\np {\n  text-wrap: pretty;\n}\nh1, h2, h3, h4, h5, h6 {\n  text-wrap: balance;\n}\n\n/*\n  10. Create a root stacking context\n*/\n#root, #__next {\n  isolation: isolate;\n}\n\n/* --------CSS reset above-------- */\n\n/*colors*/\n:root{\n  --white: white;\n  --black: black;\n  --transperant-white: rgb(255, 255, 255,0.7);\n  --red: rgb(181, 25, 25);\n  --light-black: rgb(0, 0, 0,0.4);\n  --light-black2: rgb(0, 0, 0,0.1);\n  --light-black3: rgb(0, 0, 0,0.3);\n  --grey: rgb(255, 255, 255,0.1);\n  --dark-grey: rgb(255, 255, 255,0.3);\n  /*homepage*/\n  --color-heading-hero: var(--white);\n  --color-search-btn-home: var(--white);\n  --color-search-home: var(--white);\n  --color-underline-search-home: var(--white);\n  --color-underline-search-btn-home: var(--white);\n  --bg-color-search-btn-home: var(--light-black);\n  --bg-color-search-home: var(--light-black3);\n  /*error*/\n  --bg-color-header-error: var(--red);\n  --color-header-error: var(--white);\n  /*data page*/\n  --bg-color-data-page-right: var(--light-black);\n  --bg-color-data-page-left: var(--light-black);\n  --bg-color-search-data: var(--grey);\n  --bg-color-search-btn-data: var(--light-black2);\n  --color-underline-search-data: var(--white);\n  --color-underline-search-btn-data: var(--white);\n}\n\n.main{\n  height: 100vh;\n}\n.bg_image{\n  position: absolute;\n  z-index: -1;\n  width: 100%;\n  height: 100%;\n  min-width: 1320px;\n  left: 0;\n  top: 0;\n}\ninput[type='search']::placeholder{\n  color: var(--white);\n}\n/*----------home page styling----------*/\n.home_page_holder{\n  padding-top: 100px;\n  padding-left: 10px;\n  padding-right: 10px;\n}\n.hero_heading,\n.hero_para{\n  text-align: center;\n  color: var(--color-heading-hero);\n}\n.hero_heading{\n  font-size: 3rem;\n}\n.hero_para{\n  font-size: 1.5rem;\n}\n.home_search_form{\n  display: flex;\n  height: 50px;\n  justify-content: center;\n}\n.hero_section{\n  margin-bottom: 50px;\n}\n.home_search_input{\n  width: 60vw;\n  padding-left: 10px;\n  outline: none;\n  border: none;\n  border-bottom: 2px solid var(--color-underline-search-home);\n  background-color: var(--bg-color-search-home);\n  color: var(--white);\n  font-size: 1.2rem;\n}\n.home_search_input::-webkit-search-cancel-button{\n  appearance: none;\n}\n.home_search_btn{\n  /* width: 50px; */\n  border: none;\n  border-bottom: 2px solid var(--color-underline-search-btn-home);\n  background-color: var(--bg-color-search-btn-home);\n  fill: var(--color-search-btn-home);\n}\n.home_bg_image{\n  position: absolute;\n  z-index: -1;\n  width: 100%;\n  min-width: 1220px;\n  left: 0;\n  top: 0;\n}\n.home_search_btn svg{\n  pointer-events: none;\n  width: 3rem;\n}\n.loading_screen{\n  height: 100%;\n  width: 100%;\n  display: grid;\n  place-content: center;\n  background-color: var(--transperant-white);\n  position: fixed;\n  top: 0;\n}\n\n/*Error dialog box*/\n.error_holder{\n  width: 70vw;\n  max-width: 300px;\n  height: 100px;\n}\n.error_dialog{\n  position: absolute;\n  top: 220px;\n  margin: 0 auto;\n}\n.error_header{\n  display: flex;\n  background-color: var(--bg-color-header-error);\n}\n.error_heading{\n  flex: 1;\n  text-align: start;\n  font-size: 1.1rem;\n  padding-left: 10px;\n  color: var(--color-header-error);\n}\n.error_header button{\n  width: 30px;\n}\n.error_close_btn_svg{\n  pointer-events: none;\n}\n.error_text{\n  padding: 10px;\n}\n\n/*Data page*/\n.data_page_holder{\n  display: grid;\n  grid-template-columns: 5fr 6fr;\n  padding: 30px;\n  gap: 15vw;\n  height: 100%;\n}\n/*left*/\n.data_page_left{\n  display: grid;\n  align-content: start;\n  gap: 10px;\n  background-color: var(--bg-color-data-page-left);\n  color: var(--white);\n  padding: 30px;\n  border-radius: 10px;\n  fill: var(--white);\n  position: relative;\n}\n.home_btn_svg_holder svg{\n  width: 3rem;\n}\n.data_page_search_btn{\n  border: none;\n  border-bottom: 2px solid var(--color-underline-search-btn-data);\n  background-color: var(--bg-color-search-btn-data);\n}\n.data_page_search_btn svg{\n  width: 2.3rem;\n  pointer-events: none;\n}\n.data_page_search_input::-webkit-search-cancel-button{\n  appearance: none;\n}\n.data_page_search_input{\n  width: 60%;\n  padding-left: 10px;\n  outline: none;\n  border: none;\n  border-bottom: 2px solid var(--white);\n  background-color: var(--bg-color-search);\n  color: var(--white);\n  font-size: 1.2rem;\n  flex: 1;\n}\n.data_page_search_form{\n  display: flex;\n  /* height: 50px; */\n}\n.assist_display{\n  height: 20px;\n}\n.change_unit_btn_holder{\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  font-size: 1.2rem;\n}\n.credits_for_data_page{\n  width: 100%;\n  height: 25px;\n  display: flex;\n  justify-content: center;\n  position: absolute;\n  bottom: 10px;\n  align-items: center;\n  gap: 10px;\n}\n.credits_for_data_page svg{\n  width: 1.5rem;\n}\n/*right*/\n.intro_top>.intro_temp_display{\n  font-size: 6rem;\n  text-align: center;\n}\n.intro_icon_holder{\n  display: flex;\n}\n.intro_icon_holder svg{\n  width: 3.5rem;\n}\n.intro_bottom{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n}\n.intro_location_info_holder>p:first-of-type{\n  font-size: 1.5rem;\n}\n.data_page_right>h2{\n  font-size: 1.2rem;\n  border-top: 1px solid var(--white);\n  /* border-top-color: var(--white); */\n}\n.data_page_right>.data_card{\n  height: 50px;\n  display: grid;\n  grid-template-columns: 4fr 4fr 1fr;\n  align-items: center;\n}\n.data_page_right{\n  display: grid;\n  gap: 5px;\n  overflow: auto;\n  padding: 30px;\n  background-color: var(--bg-color-data-page-right);\n  color: var(--white);\n  fill: var(--white);\n  border-radius: 10px;\n  /* background-color: rgb(255, 255, 255,0.4);\n  color: black; */\n}\n.data_page_right>.data_card>p{\n  padding-left: 10px;\n}\n.data_page_right>.data_card>p+p{\n  text-align: end;\n}\n.data_page_right>.data_card>div>svg{\n  width: 1.8rem;\n}\n.data_page_right>.data_card>div{\n  display: flex;\n  justify-content: center;\n}\n::-webkit-scrollbar{\n  background-color: transparent;\n  width: 3px;\n  height: 3px;\n}\n::-webkit-scrollbar-thumb{\n  background-color: white;\n  border-radius: 2px;\n}\n/*credits*/\n.credits{\n  position: fixed;\n  bottom: 0;\n  width: 100%;\n  height: 25px;\n  z-index: 1;\n  display: flex;\n  justify-content: center;\n  color: white;\n  fill: white;\n  align-items: center;\n  gap: 10px;\n  background-color: var(--light-black3);\n}\n.credits svg{\n  width: 1.5rem;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
